<style>
</style>

<template>
<div>
  <v-form ref="giftForm" v-model="giftValid">
    <v-switch :label="$t('Je objednávka dárek?')" v-model="basket.isGift"></v-switch>
    <v-card flat dense class="pa-2 background: secondary" v-if="basket.isGift">
      <v-row dense>
        <v-col cols="2">
          <div class="body-2 grey--text">{{ $t('Vyplňte text') }}</div>
        </v-col>
        <v-col cols="10">
      <v-textarea solo flat multi-line rows="2" counter=80 :label="$t('Darovací text')" v-model="basket.giftMessage" :rules="giftRules"></v-textarea>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="2">
          <div class="body-2 grey--text">{{ $t('Vyplňte email') }}</div>
        </v-col>
        <v-col cols="10">
          <v-text-field solo flat required :label="$t('Darovací email')" v-model="basket.shippingEmail" type="email" :rules="emailRules"></v-text-field>
        </v-col>
      </v-row>
    </v-card>
  </v-form>
</div>
</template>

<script>
import BasketMixin from '@/mixins/basket-mixin.js'
import TransfromMixin from '@gravela/vue-component-library/src/mixins/transform-mixin.js'

export default {
  mixins: [BasketMixin, TransfromMixin],
  components: {},
  data() {
    return {
      giftValid: true,
      giftRules: [(v) => (v === null || v.length === 0 || v.length <= 80) || this.transform('Text je příliš dlouhý')],
      emailRules: [
        (v) => !!v || this.transform('Požadovaná položka'),
        (v) => (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || this.transform('Neplatný email')
      ]
    }
  },
  watch: {
    giftValid() {
      this.$emit('valid', this.giftValid)
    }
  }
}
</script>
